const INITIAL_FILTERS = {
  type: undefined,
  user_email: undefined,
  user_id: undefined,
  app_id: undefined,
  from_date: undefined,
  to_date: undefined
};

export { INITIAL_FILTERS };
